/*global __CLIENT__*/
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Map, List } from 'immutable';

import immutableCreatorSelector from '../../selectors/immutableCreatorSelector';
import SidebarRelationshipListItem from './SidebarRelationshipListItem';
import '../../styles/SidebarRelationships.css';

class SidebarRelationships extends Component {
  static propTypes = {
    relationships: PropTypes.object,
    currentProjectId: PropTypes.string,
    hiddenRelationships: PropTypes.instanceOf(Map),
    selectElement: PropTypes.func,
  };

  constructor(props) {
    super(props);

    this.buildRelationships = this.buildRelationships.bind(this);
  }

  buildRelationships() {
    const {
      relationships,
      currentProjectId,
      hiddenRelationships,
      selectElement,
    } = this.props;

    return relationships.map((rel, key) => {
      return (
        <SidebarRelationshipListItem
          rel={rel}
          key={key}
          relKey={key}
          hiddenRelationships={hiddenRelationships}
          currentProjectId={currentProjectId}
          callback={selectElement}
        />
      );
    });
  }

  render() {
    const {
      closeRelationshipPanel,
    } = this.props;

    let closeButton = null;

    if (closeRelationshipPanel) {
      closeButton = <i onClick={closeRelationshipPanel} className="fa fa fa-times fa-2x" style={{ verticalAlign: 'middle' }}></i>
    }

    return (
      <div>
        <section style={{ position: 'relative' }}>
          <div style={{ float: 'right' }}>
            {closeButton}
          </div>
          <h2>
            Relationships
          </h2>
        </section>
        <table className="table table-sm" >
          <thead>
            <tr>
              <th>Predecessor</th>
              <th>Successor</th>
            </tr>
          </thead>
          <tbody style={{ fontSize: '13px' }}>
            {::this.buildRelationships()}
          </tbody>
        </table>
      </div>
    );
  }
}

const relationshipsSelector = (state, props) => {
  const {
    relationships,
  } = props;

  let output = List();

  if (relationships.size > 0) {
    relationships.forEach((currentRel) => {
      const consumerId = currentRel.get('consumer');
      const producerId = currentRel.get('producer');

      currentRel = currentRel.set('consumer', state.elements.getIn(['elements', consumerId]));
      currentRel = currentRel.set('producer', state.elements.getIn(['elements', producerId]));

      output = output.push(currentRel);
    });

    return output;
  }

  return null;
};

const SidebarRelationshipsSelector = immutableCreatorSelector(
  [
    relationshipsSelector,
  ],
  (relationships, collapseState) => {
    return {
      relationships,
    };
  }
);

@connect(SidebarRelationshipsSelector)
export default class SidebarRelationshipsContainer extends Component {
  static propTypes = {
    relationships: PropTypes.object,
    dispatch: PropTypes.func,
    currentProjectId: PropTypes.string,
  };

  render() {
    const { relationships } = this.props;
    if (!relationships || relationships.size === 0) return <span />;

    return <SidebarRelationships {...this.props} />;
  }
}



// WEBPACK FOOTER //
// ./src/components/RightColumn/SidebarRelationships.js